import { observer } from 'mobx-react';
import { useRef, useEffect } from 'react';
import { Tooltip } from 'react-tooltip';
import { AGENT_ICONS } from './AgentSidebarMenuEntry';

const getCollapseButtonId = (() => {
  let id = 0;
  return () => {
    id++;
    return 'collapse-button-' + id;
  };
})();

const AgentSidebarCollapseButton = observer(
  ({ onClick = () => {}, tooltipText = '', showTooltip = false }) => {
    const buttonId = useRef(getCollapseButtonId()).current;

    return (
      <>
        <button
          id={buttonId}
          className="agent-sidebar-collapse-button"
          onClick={onClick}
        >
          <img src={AGENT_ICONS.SIDEBAR_COLLAPSE} alt="Collapse sidebar" />
        </button>

        {showTooltip && tooltipText && (
          <Tooltip
            anchorSelect={`#${buttonId}`}
            content={tooltipText}
            place="right"
            showArrow={true}
            opacity={1}
          />
        )}
      </>
    );
  }
);

export default AgentSidebarCollapseButton;